/*
 * Copyright (c) 2020 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */

import React from 'react';
import DIYGatewayManagement from '../../components/DIYGatewayManagement';
import GlobalStore from '../../stores/GlobalStore/GlobalStore';
import './DIYGatewayManagementApp.scss';
import {
  ForgeConnectIdentity,
  IForgeConnectFunctionProps
} from "../../components/common/ForgeConnectIdentity";
import {DIYErrorPage} from "../../components/common/DIYErrorPage";
import authConfig from './../../stores/GatewayManager/ADOpenIdConfig';
import AuthenticationContext from "adal-angular";
import forgeAxiosInstance
  from "./../../stores/GatewayManager/ForgeAxiosInstance";
import './../../components/layout.scss';
import {useEffect, useState} from 'react';
import featureFlagStore from '../../utils/FeatureFlags/APFeatureFlagsStore';

/**
 * The props interface for the gateway management application.
 *
 */
export interface IDIYGatewayManagementAppProps {
  globalStore?: GlobalStore;
}

/**
 * The entry point to the DIY gateway management application.
 *
 */
// @Todo Instead of launching it from App.tsx directly use it through a Route
// At a route level configure if this particular route needs login
// This enables us to selectively apply login on certain routes
// There are drawbacks too !! How to control access to building block components ?
// Need a store level abstraction too!! GlobalStore cannot acquire token!! Will need more thinking
export const DIYGatewayManagementApp = (props: IDIYGatewayManagementAppProps) => {


  const [featureFlagInitialized, setFeatureFlagInitialized] = useState(false);

  useEffect(() => {
    featureFlagStore.init(() => setFeatureFlagInitialized(true));
  }, []);

  if (featureFlagInitialized) {
    const {globalStore} = props;
    const forgeAuthConfig = authConfig.getInstance(globalStore!.envVariables);
    const authContext = new AuthenticationContext(forgeAuthConfig);
    forgeAxiosInstance.setTokenProviderContext(authContext);
    return <ForgeConnectIdentity
      provider={authContext} globalStore={globalStore}>
      {
        ({
           isAuthenticated,
           userInfo,
           error,
           login,
           logout
         }: IForgeConnectFunctionProps) => {
          return (isAuthenticated) ?
            <DIYGatewayManagement userInfo={{
              firstName: userInfo.profile['given_name'],
              lastName: userInfo.profile['family_name'],
              userPrincipalName: userInfo.profile['upn']
            }}
                                  logout={logout}/> :
            <div className='root'>
              <div className='application-container'>
                <div className='application-main-content'>
                  <DIYErrorPage errorTitle='Unable to authenticate...'
                                message={`${error}, Please refresh the page.`}
                                showSupportLink={false}/>
                </div>
              </div>
            </div>
        }
      }
    </ForgeConnectIdentity>
  } else {
    return <div></div>;
  }

}



